import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const ICFAnnouncementCard = () => {
  return (
    <Card className="bg-gray-200/80 backdrop-blur-sm border border-black/10 shadow-sm">
      <CardHeader className="p-4 md:p-5 pb-2">
        <CardTitle className="text-lg md:text-xl font-bold text-[#1E3A8A]">
          L'indice de la Citoyenneté Française 2025 (ICF25)
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-5 pt-0 space-y-3">
        <p className="text-sm md:text-[15px] text-[#1E3A8A] leading-snug">
          Pour aborder ces sujets factuellement, sans ressenti, <strong>nous avons créé l'Indice de Citoyenneté Française (ICF)</strong>, 
          miroir de notre relation aux principes républicains, à notre modèle de société qui aspire à la Liberté, 
          à la dignité des individus et à la cohésion sociale dans un état de droit. Pas un sondage. Pas une pétition. 
          Un indice, chiffré, sourcé, public, suivi année après année.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-2 pt-1">
          <a
            href="/dossier-icf-2025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#1E3A8A] hover:bg-[#1E3A8A]/90 text-white px-4 py-2 rounded-lg font-medium text-sm transition-colors"
          >
            Lire un résumé de l'ICF25
            <ArrowRight className="ml-2" size={16} />
          </a>
        </div>
      </CardContent>
    </Card>
  );
};
